import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import "./Services.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPenNib,
  faLaptopCode,
  faMagnifyingGlass,
  faRocket,
  faShareNodes,
  faLocationDot,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";

const services = [
  {
    id: "ui-ux-design",
    category: "Design & UX",
    icon: faPenNib,
    title: "UI / UX & Website Design",
    desc:
      "Intuitive, high-converting digital interfaces engineered to build immediate trust and seamlessly guide visitors into paying customers.",
    gradient: "linear-gradient(135deg, #d946ef 0%, #8b5cf6 100%)",
  },
  {
    id: "web-development",
    category: "Engineering",
    icon: faLaptopCode,
    title: "Website & App Development",
    desc:
      "Lightning-fast, mobile-first web applications built for speed, security, and effortless scaling without tech debt.",
    gradient: "linear-gradient(135deg, #8b5cf6 0%, #2563eb 100%)",
  },
  {
    id: "search-engine-optimization",
    category: "Search Strategy",
    icon: faMagnifyingGlass,
    title: "SEO & Search Visibility",
    desc:
      "Technical audits, schema markup, and content architectures designed to rank #1 on Google and drive consistent compounding organic leads.",
    gradient: "linear-gradient(135deg, #2563eb 0%, #00d2ff 100%)",
  },
  {
    id: "social-media-marketing",
    category: "Audience & Growth",
    icon: faShareNodes,
    title: "Social Media Marketing",
    desc:
      "Engaging multi-channel storytelling and brand positioning that builds loyal communities and turns attention into inbound inquiries.",
    gradient: "linear-gradient(135deg, #ec4899 0%, #d946ef 100%)",
  },
  {
    id: "search-engine-marketing",
    category: "Paid Performance",
    icon: faRocket,
    title: "Paid Ads & Lead Generation",
    desc:
      "Targeted Google, Meta, and LinkedIn ad campaigns optimized for high ROAS, lowest CPA, and measurable customer acquisition.",
    gradient: "linear-gradient(135deg, #d946ef 0%, #2563eb 100%)",
  },
  {
    id: "local-business-growth",
    category: "Local Presence",
    icon: faLocationDot,
    title: "Local Business Growth",
    desc:
      "Hyper-local Google Business optimization, maps visibility, and review management to dominate local searches in your region.",
    gradient: "linear-gradient(135deg, #7c3aed 0%, #00d2ff 100%)",
  },
];

const Services = () => {
  const navigate = useNavigate();

  return (
    <section className="about-services" id="services-section" aria-label="Our services">
      <div className="about-services-wrap">
        <motion.header
          className="about-services-head"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <span className="about-services-kicker">Core Capabilities</span>
          <h2>Digital Marketing Services Built for High ROI</h2>
          <p>
            From high-converting web architecture to aggressive search and paid
            growth, we engineer full-funnel digital systems that scale businesses.
          </p>
        </motion.header>

        <div className="about-services-grid">
          {services.map((s, index) => (
            <motion.article
              key={s.id}
              className="about-services-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.08 }}
              onClick={() => navigate(`/services/${s.id}`)}
              tabIndex={0}
              role="button"
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  navigate(`/services/${s.id}`);
                }
              }}
            >
              <div className="card-top-row">
                <div
                  className="about-services-icon"
                  style={{ background: s.gradient }}
                >
                  <FontAwesomeIcon icon={s.icon} />
                </div>
                <span className="service-category">{s.category}</span>
              </div>

              <div className="about-services-content">
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>

              <div className="service-action-link">
                <span>Explore Service</span>
                <FontAwesomeIcon icon={faArrowRight} className="service-arrow" />
              </div>

              {/* Gradient border indicator */}
              <div className="service-accent-border" />
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
